<template>
    <div>
        <b-form-group label="Pedido Genérico" label-for="company">
            <b-form-input v-model="localOrderGeneric" placeholder="Pedido Genérico" autocomplete="off" :disabled="disabled"
                          :class="validation ? 'is-invalid': ''"/>
            <small v-if="validation" className="text-danger">
                {{ validation }}</small>
        </b-form-group>
    </div>
</template>

<script>
import {BFormGroup, BFormInput} from 'bootstrap-vue'

export default {
    components: {
        BFormGroup,
        BFormInput,
    },
    props: {
        nOrderGeneric: {
            type: String,
            default: ''
        },
        validation: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        localOrderGeneric: {
            get() {
                return this.nOrderGeneric
            },
            set(value) {
                this.$emit('update', {n_order_generic: value})
            },
        },
    },
}
</script>
